import { render, staticRenderFns } from "./StartupProgress.vue?vue&type=template&id=220240b7&"
import script from "./StartupProgress.vue?vue&type=script&lang=js&"
export * from "./StartupProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports